import * as _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogComponentBase } from '@wephone-core-ui';
import { DialogActionButton, Colors } from '@wephone-utils';
import { _tk, _ti } from '@wephone-translation';

@Component({
  selector: 'transfer-confirm-modal',
  templateUrl: 'transfer-confirm.html',
  styleUrls: ['./transfer-confirm.scss']
})
export class TransferConfirmModal extends DialogComponentBase implements OnInit {
  dialogTitle = _tk('callcenter_agent_panel.dialogs.transfer.title');
  dialogRightActions: DialogActionButton[] = [
    {
      label: _tk('public.ok'),
      action: () => {
        this.ok();
      },
      visible: () => {
        return true;
      },
      color: Colors.PRIMARY
    }
  ];

  transferData = {
    transfer_reason: '',
  };

  constructor(
    dialogRef: MatDialogRef<TransferConfirmModal>,
  ) {
    super(dialogRef);
  }

  ngOnInit(): void {
    super.ngOnInit();

  }

  ok(): void {
    this.dismiss(this.transferData);
  }
}
